/**
 * Create an array of numbers that covers a range
 * @see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#sequence_generator_range
 */
export function createArrayWithRange(start: number, stop: number, step: number = 1): ReadonlyArray<number> {
  if (typeof start !== 'number' || typeof stop !== 'number') {
    return [];
  }

  if (typeof step !== 'number' || isNaN(step)) {
    step = 1;
  }

  return Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
}
